// Mirrors _features/roles/state/slice.js's shape. Drops the old
// features/Permissions/permissionSlice.js's `permissions` and
// `userPermissions` fields - both confirmed dead writes (`state.permission
// .permissions`/`state.permission.userPermissions` have zero readers
// anywhere in the codebase; the real current-user-permissions copy lives at
// `state.auth.userPermissions`, written by the same `useUserPermissions`
// hook that used to double-write here "for consistency" - see
// src/hooks/useUserPermissions.js, fixed to drop that dead second write).
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const DEFAULT_SORT = "-createdAt";

const initialState = {
  selectedFilters: {
    sort: DEFAULT_SORT,
  },
};

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: DEFAULT_SORT,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.permission) {
        const persistedFilters = action.payload.permission.selectedFilters;

        return {
          ...state,
          selectedFilters: {
            ...(persistedFilters && typeof persistedFilters === "object" ? persistedFilters : {}),
            sort: persistedFilters?.sort || DEFAULT_SORT,
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } = permissionSlice.actions;

export default permissionSlice.reducer;
